var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 8.5H14.3333C15.2533 8.5 16 9.24667 16 10.1667V19.3333C16 20.2533 15.2533 21 14.3333 21H2.66667C1.74667 21 1 20.2533 1 19.3333V10.1667C1 9.24667 1.74667 8.5 2.66667 8.5Z",
    stroke: "#959291",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C5.73833 1 3.5 3.23833 3.5 6V8.5H13.5V6C13.5 3.23833 11.2617 1 8.5 1Z",
    stroke: "#959291",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.1733C8.845 14.1733 9.125 14.4533 9.125 14.7983C9.125 15.1433 8.845 15.4233 8.5 15.4233C8.155 15.4233 7.875 15.1433 7.875 14.7983C7.875 14.4533 8.155 14.1733 8.5 14.1733Z",
    stroke: "#959291",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.12327c928873d42bd52258940517ffae.svg";
export { ForwardRef as ReactComponent };